import React, { Component } from 'react';
import { Icon } from '@material-ui/core';
import 'react-toastify/dist/ReactToastify.css';
import './AchievementNotification.scss';

class AchievementNotification extends Component {
  startPos = null;

  mouseDown(event) {
    this.startPos = { x: event.clientX, y: event.clientY };
  }

  mouseUp(event) {
    if (event.clientX === this.startPos.x && event.clientY === this.startPos.y) {
      this.props.onClick();
    }
  }

  render() {
    const { achievement } = this.props;

    return (
      <div className="achievement-wrapper">
        <div className="achievement-content" onMouseDown={event => this.mouseDown(event)} onMouseUp={event => this.mouseUp(event)} >
          <div className="achievement-header">
            <div className="achievement-header-text">Achievement unlocked!</div>
            <div className="achievement-header-close" onClick={() => this.preventClick = true}>
              <Icon>close</Icon>
            </div>
          </div>
          <div className="achievement-image">
            <img alt="achievement-logo" src={achievement.picture} draggable="false" />
          </div>
          <div className="achievement-name">{achievement.name}</div>
          <div className="achievement-description">{achievement.description}</div>
        </div>
      </div>
    );
  }
}

export default AchievementNotification;



// WEBPACK FOOTER //
// ./src/components/AchievementNotification.js